import { useEffect } from 'react';
import { osName } from 'react-device-detect';
import { useLocation, useNavigate } from 'react-router-dom';
import { ampli } from '../../ampli';
import { browserStorageKeys } from '../../constants/browserStorageKeys/browserStorageKeys.constant';
import { pageInfo } from '../../constants/pageInfo/pageInfo.constant';
import { userEnvironment } from '../../constants/userEnvironment/userEnvironment.contant';

const noRedirectToDownloadAppPageList = [
  pageInfo.downloadAppPage.path,
  pageInfo.pluvaAutoPage.path,
  pageInfo.pluvaAutoBusinessPage.path,
];

export const useCheckUserEnvironment = () => {
  const location = useLocation();
  const navigate = useNavigate();

  useEffect(() => {
    if (window.ReactNativeWebView) {
      ampli.기타운영유저정보({
        '접속 환경': 'app',
        'OS 정보': osName,
      });
    } else {
      ampli.기타운영유저정보({
        '접속 환경': 'web',
        'OS 정보': osName,
      });
    }
  }, []);

  useEffect(() => {
    if (
      userEnvironment.isMobileWeb &&
      location.key === 'default' &&
      noRedirectToDownloadAppPageList.findIndex((pagePath) => pagePath === location.pathname) === -1
    ) {
      sessionStorage.setItem(browserStorageKeys.openOnAppPagePath, location.pathname);
      // TODO : 앱 다운로드 페이지 스펙이 다시 정해진 후 재구현 https://gint-team.atlassian.net/browse/PVM-1700
      // navigate(pageInfo.downloadAppPage.path);
    }
  }, []);
};
